const NEWLY_CREATED = 'newly_created'
const OLDER_CREATED = 'older_created'
const NEWLY_UPDATED = 'newly_updated'
const OLDER_UPDATED = 'older_updated'
const ALPHABETICAL_A_TO_Z = 'alphabetical_a_to_z'
const ALPHABETICAL_Z_TO_A = 'alphabetical_z_to_a'
const CUSTOM_FIELD_ASC = 'custom_field_asc'
const CUSTOM_FIELD_DESC = 'custom_field_desc'

const orderFilter = {
  ALPHABETICAL_A_TO_Z,
  ALPHABETICAL_Z_TO_A,
  CUSTOM_FIELD_ASC,
  CUSTOM_FIELD_DESC,
  NEWLY_CREATED,
  NEWLY_UPDATED,
  OLDER_CREATED,
  OLDER_UPDATED,
}

export default orderFilter
